<template>
  <autocomplete v-model="searchQuery" :options="options" :onItemSelected="onSearchItemSelected" :onInputChange="onInputChange" :required="required">
    <template #item="props">
      {{props.item.name}}
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  emits: ['selected'],
  name: 'TagAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    minCharacter: {
      type: Number,
      default: 2
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    includes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      }
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Tag name')
    }
  },
  methods: {
    onInputChange(query) {
      const params = {
        includes: this.includes,
        sort: [
          {
            key: 'name',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            filters: [
              ['name', 'ct', query.trim()]
            ]
          }
        ]
      }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + 'tags', { params })
            .then(response => {
              resolve(response.body.data)
            })
        })
      }
    },
    onSearchItemSelected(item) {
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
